export const ADD_ITEM_TO_USERLIST = "ADD_ITEM_TO_USERLIST";
export const SELECTED_CINEMA_SHOWTIME = "SELECTED_CINEMA_SHOWTIME";
export const TRIVIA_ONBOARDING_VIDEO = "TRIVIA_ONBOARDING_VIDEO";
export const LOGIN = "LOGIN";
